export enum StylingType {
  official = "officialstyling",
  stylehint = "stylehint"
}

export enum SiteType {
  Mobile = "mobile",
  Desktop = "desktop",
  Responsive = "responsive",
  App = "app"
}

export enum Media {
  APP = "app",
  WEB = "web"
}

export enum DeviceType {
  PC = "PC",
  SP = "SP",
  RS = "RS" // * Responsive
}

export enum PageType {
  StylingBook = "stylingbook"
}

export enum BRAND_LIST {
  UQ = "uq",
  GU = "gu"
}

export enum GABrandList {
  UQ = "uq",
  GU = "GU"
}

export enum BRAND_NAME_LIST {
  UQ = "uniqlo",
  GU = "gu"
}

export enum COUNTRY {
  HK = "hk",
  TW = "tw"
}

export enum LANGUAGE {
  ZHTW = "zh_TW",
  ZHHK = "zh_HK",
  ENGB = "en_GB"
}

export type COUNTRY_CONFIG<T> = { [key in COUNTRY]: T };
export type COUNTRY_CONFIG_WITH_LANG<T> = {
  [key in COUNTRY]: { [L in LANGUAGE]?: T };
};

export type Maybe<T> = T | null | undefined;

export enum StylingSortEnum {
  latest = "latest", // 新着
  popular = "popular" // 人气
}

export enum SortRouterParamEnum {
  published = "published",
  likes = "likes"
}

export enum StyleGenderEnum {
  WOMEN = "WOMEN",
  MEN = "MEN",
  KIDS = "KIDS",
  BABY = "BABY"
}
export type StyleGenderType = 1 | 2 | 3 | 4;

export type DepartmentIdEnum = "men" | "women" | "kids" | "baby";

export enum UserTypeEnum {
  CONSUMER = "CONSUMER",
  OFFICIAL = "OFFICIAL",
  STAFF = "STAFF",
  KOL = "KOL",
  KOL_BADGE = "KOL_BADGE",
  STYLE_HINTER = "STYLE_HINTER"
}
export type UserTypeTypes = keyof typeof UserTypeEnum;

export const UserTypeMap: Record<UserTypeEnum, number> = {
  [UserTypeEnum.CONSUMER]: 0,
  [UserTypeEnum.OFFICIAL]: 1,
  [UserTypeEnum.STAFF]: 2,
  [UserTypeEnum.KOL]: 3,
  [UserTypeEnum.KOL_BADGE]: 4,
  [UserTypeEnum.STYLE_HINTER]: 5
};

export const UserTypeNumberMap: Record<number, UserTypeEnum> = {
  0: UserTypeEnum.CONSUMER,
  1: UserTypeEnum.OFFICIAL,
  2: UserTypeEnum.STAFF,
  3: UserTypeEnum.KOL,
  4: UserTypeEnum.KOL_BADGE,
  5: UserTypeEnum.STYLE_HINTER
};

export type FlagColorEnum = "normal" | "discount";

export enum StockStatusEnum {
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  COLOR_OUT_OF_STOCK = "COLOR_OUT_OF_STOCK"
}
export type StockStatusType = keyof typeof StockStatusEnum;

export enum STYLING_SORT_BY {
  PUBLISHED_AT_DESC = "published_at:desc",
  SH_LIKES_7DAYS_DESC = "sh_likes_7days:desc",
  SH_LIKES_31DAYS_DESC = "sh_likes_31days:desc",
  EC_LIKES_TOTAL_DESC = "ec_likes_total:desc",
  DISPLAY_START_AT_DESC = "display_start_at:desc"
}

export type ProductColors =
  | "white"
  | "gray"
  | "black"
  | "pink"
  | "red"
  | "orange"
  | "beige"
  | "brown"
  | "yellow"
  | "green"
  | "blue"
  | "purple";

export type RouterType = {
  region: string;
  language: string;
  type: string;
};

export interface ErrorResponse {
  id?: string;
  code: number;
  message?: string;
  details: Array<{ [key: string]: string }>;
  httpStatusCode?: number;
}

/**
 * Styling Filters Type
 */
export interface FiltersPayload {
  departmentId?: string; // department Id
  type: string; // Styling Book (sb) or StyleHint (sh)
  httpFailure?: string;
  rootId: string | number;
  contentLanguage?: string; // Language code: zh-HK, zh-TW, en-GB
}

export interface HashtagsType {
  hashtag: string;
}

export interface FiltersResponseType {
  styleCategories?: Array<StyleCategoriesTreeType>;
  tagCategories?: Array<TagCategoriesType>;
  features?: Array<FeaturesType>;
  hashtags?: Array<HashtagsType>;
}

export interface StylingFiltersData {
  loading: boolean;
  featureList: Array<FeaturesType>;
  coordinationList: Array<TagCategoriesType>;
  hashtagList: Array<HashtagsType>;
  categoryList: Array<StyleCategoriesTreeType>;
  isReloadFilters: boolean;
}

export interface StyleCategoriesType {
  id?: number;
  name?: string;
  localizedName?: string; // Style category name in regional language
  styleCount?: number; // Number of approved outfits for given StyleHint category
}
export interface StyleCategoriesTreeType extends StyleCategoriesType {
  styleCategories?: Array<StyleCategoriesType>;
}

export interface TagCategoriesType {
  totalStyles?: number; // The count of the styles which are tagged with current tag
  code?: string; // The identiter of the tag
  name?: string; // The name of the tag
  displayCode?: string; // The tag display code
}

export interface FeaturesType {
  id?: string; // Represents abstract description name
  title?: string; // The title  describes the feature
}

/**
 * Stylehint Styling Type
 */
export interface LargeStylehintStylingPayload {
  genderCode?: Array<number>; // 1 = MEN, 2 = WOMEN, 3 = KIDS,  4 = BABY
  httpFailure?: string;
}

export interface SHlargeImages {
  order?: number;
  hashtag?: string;
  outfitId?: number;
  imageUrl?: string;
  description?: string;
  createdAt?: number;
  updatedAt?: number;
  styleGender?: StyleGenderType; // 1 = MEN, 2 = WOMEN, 3 = KIDS,  4 = BABY
}

export type StylehintListPayload = {
  departmentIds?: Array<number>;
  hashTags?: string;
  categoryIds?: string;
  userType?: Array<number>; // 0 = Consumer 1 = Official 2 = Staff 3 = KOL 4 = KOL(Badge) 5 = StyleHinter
  colors?: string; // Available values : white, gray, blue, purple, black, pink, red, orange, beige, brown, yellow, green
  minModelHeight?: number;
  maxModelHeight?: number;
  unit?: string; // Unit of model height. If maxModelHeight and minModelHeight is not present, this parameter will be ignored.
  order?: string;
  limit?: number; // default value is 10. Max value is 50.
  offset?: number;
  httpFailure?: string;
  productId?: string;
  userId?: number;
};

export interface StylehintListData {
  loading: boolean;
  stylehint_list: StylehintListType;
  large_loading: boolean;
  stylehint_large_list: Array<SHlargeImages>;
  hasMore: boolean;
  noResult: boolean;
  errorCode: string;
  currentSort: string;
  hasClickSort: boolean;
  SH_list: Array<StylesInfo>;
  current_list: Array<SHNormalImages>;
}

export interface StylehintListType {
  pagination: Pagination;
  images: Array<SHNormalImages>;
}

export interface Pagination {
  total?: number;
  count?: number;
  offset?: number;
  page?: number;
}

export interface SHNormalImages {
  outfitId?: string;
  styleImageUrl?: string;
  isFromInstagram?: boolean;
  originalSourceUrl?: string;
  departmentId?: string;
  totalLikes?: number;
  last7DaysLikes?: number;
}

/**
 * Official Styling Type
 */
export interface LargeOfficialStylingPayload {
  httpFailure?: string;
  featureIds?: string;
  departmentIds?: string;
  contentLanguage?: string;
}

export type SBlargeImagesData = Array<SBlargeImages>;

export interface SBlargeImages {
  featureId: string;
  imageUrl?: string;
  title: string;
  description: string;
}

export interface OfficialListPayload {
  categoryIds?: string; // categoryIds Ids
  featureIds?: string; // feature Ids
  tagCodes?: string; // tagCodes
  departmentIds?: string; // department Ids.
  productIds?: string; // Identifier of Product.
  colors?: string; // Available values : white, gray, blue, purple, black, pink, red, orange, beige, brown, yellow, green
  order?: string; // Example : order=published_at:desc,sh_likes_7days:desc
  limit?: number; // Default value is 10. Max value is 50.
  offset?: number; // A number of offset for pagination, default value is 0
}

export interface OfficialListType {
  styles: Array<SBNormalImages>;
  pagination: Pagination;
}

export interface SBNormalImages {
  styleId: string;
  imageUrl: string;
}

export interface OfficialListData {
  loading: boolean;
  official_list: OfficialListType;
  large_loading: boolean;
  official_large_list: SBlargeImagesData;
  hasMore: boolean;
  current_list: Array<SBNormalImages>;
  noResult: boolean;
  errorCode: string;
  showFilterPanel: boolean;
  SB_list: Array<StylesInfo>;
}

/**
 * Styling Detail Type
 */
export interface DetailStylingPayload {
  styleId: string;
  httpFailure?: string;
  type: string; // Styling Book (sb) or StyleHint (sh)
}

export interface UserInfoBase {
  image?: string;
  name: string;
  height: number;
  isFromInstagram: boolean;
  userType: UserTypeTypes;
}

export interface SHStoreInfo {
  storeName: string;
  brand: string;
  region: string;
  storeId: number;
}

export interface UserInfoOther {
  validatedDate: number; // Date on which style was validated. It will be 10 digit unix timestamp
  comment: string;
  id?: number; // Author ID in UGC
}

export interface FlagComponent {
  code: string; // Identifiers for the flags
  id: number;
  name: string; // Localized name of the product's flags
  flagColor: FlagColorEnum;
  nameWording?: {
    flagWithTime: string; // Localization ID of flag test with time. Clients should use this field instead of name if its present.
    substitutions?: {
      date?: string;
      month?: string;
      flagName?: string;
    };
  };
}

export interface FlagsType {
  productFlags: Array<FlagComponent>;
  priceFlags: Array<FlagComponent>;
}

export interface CurrencyType {
  code: string;
  symbol: string;
}

export interface PriceType {
  base: {
    currency: CurrencyType;
    value: number;
  };
  promo: {
    currency: CurrencyType;
    value: number;
  };
}

export type GenderCategory = "MEN" | "WOMEN" | "KIDS" | "BABY" | "UNISEX";

export interface ProductDetailType {
  l2Id: string; // Product identifier
  productName: string; // Name of the product in PDP page
  productId: string; // productId of the product that is related to the style
  priceGroup?: string; // priceGroup of the product that is related to the style
  box?: Array<number>;
  flags: FlagsType;
  stockStatus: string;
  price: ProductPriceHandType;
  genderCategory: string;
  pdpImageUrl: string; // This will be url of product image
  color: {
    name: string; // Localized name
    code: string; // example: AAA00
    displayCode: string; // example: 00
  };
  active?: boolean; // Deprecated on GP4.0-3.0
  size: string; // Size of the product used by StyleHint user
  promotionText?: string; // king promotion text
  productCode: string;
}

export interface ProductModels {
  positionId?: string; // model position
  positionName?: string; // position of the model in style image
  products: Array<ProductDetailType>;
}

export type DetailUserType = UserInfoBase & SHStoreInfo & UserInfoOther;

export interface StylingDetailType {
  last7DaysLikes?: number; // Likes received in last 7 days
  totalLikes?: number; // Total likes recieved
  userInfo?: DetailUserType;
  styleImageUrl: string; // Link to style image
  publishedAt?: number; // Date on which outfit was approved
  hashtags?: Array<string>; // Hashtags added by user for the outfit
  modelHeight?: number; // height of the model
  gender?: number; // 1:Men, 2:Women, 3:Kids, 4:Baby, 5:Prefer Not to Say. Gender type the dress is made for. This is only present for StyleHint
  models: Array<ProductModels>;
  postTag?: string; // To identify the nature of outfit post, for normal outfits this field will not be present
}

export interface ImageInfo {
  styleId: string;
  styleImageUrl: string;
}

export interface StylesInfo extends ImageInfo {
  isFavorite: boolean;
  likeCounts?: number;
}

export enum DetailFromPageEnum {
  top = "top",
  related = "related",
  changeId = "changeId",
  changeTab = "changeTab"
}
export interface DetailStylingData {
  detailInfo: StylingDetailType;
  loading: boolean;
  carouselList: Array<ImageInfo>;
  carouselIndex: number;
  fromPage: string;
  previousProductIds: string;
  errorCode: string;
}

/**
 * Related Styling StyleHint Type
 */
export interface RelatedStylingStylehintPayload {
  productIds: string;
  departmentIds?: Array<number>;
  order?: string;
  userType?: Array<number>; // 0 = Consumer 1 = Official 2 = Staff 3 = KOL 4 = KOL(Badge) 5 = StyleHinter
  limit?: number; // default value is 10. Max value is 25.
  offset?: number;
  httpFailure?: string;
}

export type RelatedStylingStylehintUserInfoType = UserInfoBase &
  SHStoreInfo & { id: number };
export interface RelatedStylingStylehintType {
  last7DaysLikes?: number; // Likes received in last 7 days
  totalLikes?: number; // Total likes recieved
  id: number; // UGC ID of the outfit
  image?: string; // Link to style image
  userInfo?: RelatedStylingStylehintUserInfoType;
  gender?: string; // Gender type the outfit is made for
  modelHeight?: number; // Height of the model
}

export interface RelatedStylingStylehintData {
  styles: Array<RelatedStylingStylehintType>;
  loading: boolean;
  carousel_styles: Array<SHNormalImages>;
  carousel_loading: boolean;
}

/**
 * Related Styling Official Type
 */
export interface RelatedStylingOfficialData {
  styles: Array<SBNormalImages>;
  loading: boolean;
  carousel_styles: Array<SBNormalImages>;
  carousel_loading: boolean;
}

/**
 * Favorites Styling Type
 */
export interface FavoritesStylingPayload {
  ids: string;
  httpFailure?: string; // default: false
}

export type FavoritesStylingData = Array<string>;

export interface FavoritesStylingResponse {
  result: FavoritesStylingData;
  status: string;
}

export type PostFavoritesStylingPayload = [{ styleId: string }];

export type OperateFavoritesResponse = { status: string };

export type DelFavoritesStylingPayload = {
  styleId: string;
  httpFailure?: string; // default: false
};

/**
 * Favorites Item Type
 */

export interface FavoritesItemData {
  spuInfo: {
    productCode: string;
  };
  status: string;
  summaryInfo: {
    productCode: string;
  };
}

export interface FavoritesItemResponse {
  msg: string;
  msgCode: string;
  success: boolean;
  resp: Array<FavoritesItemData>;
  total: number;
}

export type PostFavoritesItemPayload = [
  { productCode: string; skuCode?: string }
];

export type DelFavoritesItemPayload = Array<string>;

export interface StylingWishlistData {
  stylingLoading: boolean;
  stylingSBWishlist: FavoritesStylingData;
  stylingSHWishlist: FavoritesStylingData;
}

export interface ItemWishlistData {
  itemLoading: boolean;
  favoritesItemList: Array<string>;
}

/**
 * User Profile Type
 */
export type UserInfoType = UserInfoBase & SHStoreInfo & OtherUserInfoType;

export type UserProfileResponseData = {
  pagination: Pagination;
  userInfo?: UserInfoType;
  styles?: Array<UserProfileStyles>;
};
export interface UserProfileData extends UserProfileResponseData {
  limit: number;
  hasMore: boolean;
  errorCode: string;
  loading: boolean;
}

export type OtherUserInfoType = {
  id: number;
  bio: string;
  storeOrgCode: string;
};

export type UserProfileStyles = {
  last7DaysLikes: number;
  totalLikes: number;
  id: number;
  originalSourceUrl: string;
  isFromInstagram?: boolean;
  styleImageUrl: string;
  modelHeight: number;
};

export type UserProfilePayload = {
  limit: number;
  offset: number;
  userId: number;
};

/**
 * Firebase Gender Type
 */
export type GenderObjType = {
  women: boolean;
  men: boolean;
  kids: boolean;
  baby: boolean;
};

export type FirebaseGenderType = {
  sb: GenderObjType;
  sh: GenderObjType;
};

export interface GenderOptionType {
  key: string;
  value: string;
  code: number;
  lid: string;
  displayLid: string;
}

export type FirebaseDataType = {
  sb_tab_gender: GenderObjType;
  sh_tab_gender: GenderObjType;
  sb_wish_icon: boolean;
  sb_wish_count: boolean;
  sh_wish_icon: boolean;
  sh_wish_count: boolean;
};

/**
 * Firebase Wish Type
 */
export type WishObjType = {
  icon: boolean;
  count: boolean;
};

export type FirebaseWishType = {
  sb: WishObjType;
  sh: WishObjType;
};

/**
 * PageView
 */
export type PageViewBaseOption = {
  event: string;
  pageUrlPath: string;
  pageTitle: string;
  previousPageExists: boolean;
  brand: GABrandList;
  siteType: SiteType;
  pageType: PageType;
  subID: string;
  loginState: boolean;
};

/**
 * TrackEvent
 */
export type GATrackEventType = {
  _clear?: boolean;
  brand?: GABrandList;
  event?: string;
  value?: number;
  eventAction: string;
  eventCategory: string;
  eventLabel: string;
  eventValue?: string;
  siteType: SiteType;
};

/**
 * Country Env
 */
// export type CountryEnv = Partial<EnvType>;
export type CountryEnv = {
  clientId: string;
  sbRootId: string | number;
  shRootId: string | number;
  firebaseApiKey: string;
  firebaseProjectId: string;
  firebaseAppId: string;
  firebaseMeasurementId: string;
  storeDomain: string;
  faqUrl: string;
  faqUrlForEn?: string;
  showAboutApp: boolean;
};

export interface HrefLangListType {
  hrefLang: string;
  alternateHref: string;
}

/**
 * UGC Official Styling
 */
export interface OfficialListUgcPayload {
  style_category_id?: string; // categoryIds Ids. Max items: 5
  feature_id?: string; // Max count: 10
  tag_code?: string; // Max count: 10
  gender_id?: string; // department Ids.
  product_id?: string; // Identifier of Product. Max items: 100
  product_colors?: string;
  colors?: string; // Available values : white, gray, blue, purple, black, pink, red, orange, beige, brown, yellow, green
  style_id?: string; // Max items: 25
  order?: string;
  page_size?: number; // min: 1, max: 100, Default value: 20
  page?: number; // page number, Default value: 1
  price_group_seq?: string;
}

export interface OfficialListUgcResponse {
  status: string;
  result: OfficialListUgcType;
}

export interface OfficialListUgcType {
  total_styles: number;
  page: number;
  styles: Array<SBNormalUgcImages>;
}

export interface SBNormalUgcImages {
  style_id: string;
  image_original: string;
}

export interface LargeOfficialStylingUgcPayload {
  gender_id?: string;
  feature_id?: string;
  content_language?: string;
}

export interface LargeOfficialStylingUgcResponse {
  status: string;
  result: SBlargeImagesUgcData;
}

export type SBlargeImagesUgcData = Array<SBlargeUgcImages>;

export interface SBlargeUgcImages {
  feature_id: string;
  feature_img_url?: string;
  gender_id: number;
  gender_name: string;
  rank: number;
  banner_type: number;
  title: string;
  description: string;
}

/**
 * UGC Filter Styling
 */
export interface CategoryFilterUgcResponse {
  status: string;
  result: { style_categories: Array<CategoryFilterUgcData> };
}

export interface CategoryFilterUgcData {
  id_ugc_style_category: number;
  name: string;
  localized_name: string;
  style_count: number;
  style_categories?: Array<CategoryFilterUgcData>;
}

export interface CoordinateFilterUgcResponse {
  status: string;
  result: { tag_categories: Array<CoordinateFilterUgcData> };
}

export interface CoordinateFilterUgcData {
  total_styles: number;
  category_code: string;
  category_name: string;
  tags: Array<CoordinateTagsUgcData>;
}

export interface CoordinateTagsUgcData {
  total_styles: number;
  tag_code: string;
  tag_name: string;
  tag_display_code?: string;
  rank: number;
  genders: Array<{
    total_styles: number;
    gender_id: number;
    gender_name: string;
    image_original: string;
  }>;
}

/**
 * UGC StyleHint Styling
 */
export interface StylehintListUgcPayload {
  source_network?: Array<string>;
  hash_tags?: Array<string>;
  colors?: Array<string>;
  product_id?: Array<string>;
  product_categories?: Array<string>;
  product_colors?: Array<string>;
  id_ugc_dist_content?: Array<number>;
  style_gender?: Array<number>;
  order?: string;
  result_limit?: number;
  page?: number;
  min_model_height?: number;
  max_model_height?: number;
  min_model_height_inch?: number;
  max_model_height_inch?: number;
  style_category_id?: Array<number>;
  user_type?: Array<number>;
  org_code?: Array<string>;
  store_ids?: Array<number>;
  id_app_user?: number;
  id_ugc_author_data?: number;
  item_size_code?: string;
  priority_flag?: boolean;
}
export interface StylehintListUgcResponse {
  total_result_count: number;
  result_count: number;
  page: number;
  content_list?: Array<SHNormalUgcImages>;
}

export interface SHNormalUgcImages {
  admin_name?: string;
  id_ugc_dist_content: number;
  dist_approved: boolean;
  media_type: string;
  created_date: string;
  updated_date: string;
  published_date: string;
  geo_location: {
    latitude: number;
    longitude: number;
    place_name: string;
  };
  description: string;
  html_description: string;
  comments: number;
  likes: number;
  ec_info: {
    like_7days_delta: number;
    like_total: number;
  };
  image_original: string;
  image_resize: string;
  video_source?: string;
  source_network: string;
  link_to_url: string;
  author: AuthorUgcType;
  hash_tags: Array<string>;
  custom_tags: Array<string>;
  custom_tag_list: Array<{
    id_ugc_dist_custom_tag?: number;
    tag_name?: string;
  }>;
  attributes: Array<ImgCoordinatesUgcType>;
  products?: Array<DetailProductsUgcType>;
  gender: number;
  deleted_at: string;
  model_height: number;
  model_height_inch: number;
  brand_name: string;
  region_name: string;
  origin_region: string;
  origin_id_ugc_dist_content: number;
  priority: number;
  ugc_published_at: string;
  post_tag?: string;
}

export interface DetailProductsUgcType {
  box_normalized: Array<number>;
  ugc_item: UgcItemType;
}

export interface UgcItemType {
  categories: Array<{
    category_id?: string;
    category_name?: string;
  }>;
  fr_color_name: string;
  score: number;
  im_name?: string;
  product_id: string;
  display_color_code: string;
  image_url: string;
  title: string;
  product_link: string;
  mobile_link: string;
  tag_type: number;
  deleted_at: string;
  ugc_category: string;
  sizes: Array<string>;
  item_size: string;
  item_size_code: string;
}

export interface ImgCoordinatesUgcType {
  box: Array<number>;
  detected_color: string;
  id_ugc_content_detail: number;
  intermediate_category: string;
  object_label: string;
  score: number;
}

export interface AuthorUgcType {
  id_ugc_author_data: number;
  user_name: string;
  nick_name: string;
  picture_url: string;
  followers: string;
  posts: string;
  image_source: string;
  user_type?: number;
  user_types?: Array<number>;
  user_height: number;
  user_height_inch: number;
  user_bio: string;
  store_info: StoreUgcType;
}

export interface StoreUgcType {
  org_code: string;
  store_id: number;
  store_name: string;
  brand_name: string;
  region_name: string;
}

export interface LargeStylehintStylingUgcPayload {
  style_gender?: Array<number>;
}

export interface LargeStylehintStylingUgcResponse {
  hashtags: Array<SuggestHashtagsUgcType>;
}

export interface SuggestHashtagsUgcType {
  order?: number;
  hashtag?: string;
  outfit_id?: number;
  image_url?: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
  style_gender?: number; //1.MEN 2.WOMEN 3.KIDS 4.BABY
}

/**
 * UGC Detail Styling
 */
export interface StylingOfficialDetailUgcResponse {
  status: string;
  result: StylingOfficialDetailUgcType;
  error?: ErrorResponse;
}

export interface StylingOfficialDetailUgcType {
  style: {
    style_id: string;
    image_original: string;
    gender_id: string;
    gender_name: string;
    caption: string;
    description: string;
  };
  coordinate: Array<ProductCoordinateUgcType>;
}

export interface ProductCoordinateUgcType {
  coordinate_id: string;
  position_id: string;
  position_name: string;
  products?: Array<ProductUgcType>;
}

export interface ProductUgcType {
  im_name: string;
  product_id: string;
  price_group_seq: string;
  title: string;
  color_code: string;
  display_color_code: string;
  color_name: string;
  ugc_category: string;
  product_link: string;
  image_url: string;
  is_future_product: boolean;
}

export interface ProductPriceHandType {
  minPrice: string;
  maxPrice: string;
}

export interface ProductDetailResponseHandType {
  msg: string;
  msgCode: string;
  success: boolean;
  resp: Array<ProductDataHandType>;
  total: number;
}

export type ColorListType = Array<{
  chipPic: string; //chip图地址
  styleText: string; //颜色别名
  style: string; //颜色名称
  colorNo: string; //颜色编码
}>;

export interface ProductDataHandType {
  originPrice: number; //初上市价
  score: string; //商品评分
  mainPic: string; //主图地址
  minSize: string; //最小尺码
  stock: string; //库存情况
  hasStock: string; //是否有库存 N: 表示售罄，Y:表示有库存
  gdeptValue: string; //G部门编码值
  priceColor: string; //价格颜色
  colorList: ColorListType; //颜色信息
  evaluationCount: string; //评论数量
  minPrice: string; //最小价格
  name: string; //商品名称
  maxPrice: string; //最大价格
  code: string; //品番号
  maxSize: string; //最大尺码
  enabledFlag: string; //是否生效
  identity: Array<any>; //角标列表
  approval: string; //上下架状态
  sex: string; //性别
  fullName: string; //商品全名
  label: string; //角标
  labelPic: string; //角标图片
  timeLimitedBegin: string; //限时特优开始时间
  timeLimitedEnd: string; //限时特优结束时间
  productCode: string; //商品spu编码
}

export declare const IMAGE_RATIO_1X1 = "1x1";
export declare const IMAGE_RATIO_16X9 = "16x9";
export declare const IMAGE_RATIO_3X4 = "3x4";
export declare const IMAGE_RATIO_4X3 = "4x3";
export declare const IMAGE_RATIO_2X1 = "2x1";
export declare const IMAGE_RATIO_6X1 = "6x1";
export declare const IMAGE_RATIO_3X1 = "3x1";
export declare const IMAGE_RATIO_5X2 = "5x2";
export declare const IMAGE_FULL_WIDTH = "full-width";
export type ImageRatio =
  | typeof IMAGE_RATIO_1X1
  | typeof IMAGE_RATIO_16X9
  | typeof IMAGE_RATIO_3X4
  | typeof IMAGE_RATIO_4X3
  | typeof IMAGE_RATIO_3X1
  | typeof IMAGE_RATIO_6X1
  | typeof IMAGE_RATIO_5X2
  | typeof IMAGE_RATIO_2X1
  | typeof IMAGE_FULL_WIDTH;
